var map = {
	"./captain-card_small.svg": 9876,
	"./daily-card_small.svg": 7699,
	"./gold-card_small.svg": 5510,
	"./svg/captain_card_small.svg": 2927,
	"./svg/daily_card_small.svg": 2993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6925;